"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deposit = void 0;
const web3_1 = __importDefault(require("web3"));
const routerAbi_1 = require("./routerAbi");
const deposit = async (contractAddress, vault, asset, amount, memo) => {
    const web3 = new web3_1.default();
    const routerContract = new web3.eth.Contract(routerAbi_1.routerAbi, contractAddress);
    const data = routerContract.methods.deposit(vault, asset, amount, memo).encodeABI();
    return data;
};
exports.deposit = deposit;
